module.exports = __webpack_public_path__ + "img/wiewiory.jpg.mini.b0439fe2.jpg";